import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Form, Card } from 'react-bootstrap';
import { getTraducaoTrocaPor as trad, getCampoTraducao as tradCampo } from '../../../utils/getTraducoes';
import { ColunasPerguntas } from '../utils/toolsforms';

const PerguntasRespostas = (props) => {
    const [perguntas, setPerguntas] = useState([]);
    useEffect(() => {        
        setPerguntas(props.pergrespevento.filter(itens => (parseInt(itens.passo) !== 6)));
    },[props.pergrespevento])
        
    if(!perguntas.length){
        return null;
    }
    
    const trads = props.trads;
    const lingua = props.lingua;

    let joins = [];
    let total = perguntas.length;
    return (    
        <Card className="mb-3">
            <Card.Header>
                <Card.Title>
                {trad(trads,'LABELQUIZ',lingua)}
                </Card.Title>
            </Card.Header>
            <Card.Body>
                {perguntas.map((itens, indice) => {
                        const subperguntas = itens.resposta.filter(resp => {return resp.mostrarpergunta&&resp.mostrarpergunta.idpergunta});
                        
                        if(itens.portugues.length > 20){
                            return (
                                <Form.Row key={indice}>
                                    {ColunasPerguntas(itens, trads, trad, tradCampo, lingua, props.styles, props.form, "12")}
                                </Form.Row>
                            );
                        }else if(subperguntas.length){
                            return (
                                <Form.Row key={indice}>
                                    {ColunasPerguntas(itens, trads, trad, tradCampo, lingua, props.styles, props.form, "8")}
                                </Form.Row>
                            );
                        }else if(itens.mostraresposta===null){

                            total--;                                                    
                            if(joins.length === 3){
                                joins = [];
                            }
                
                            joins = joins.concat(ColunasPerguntas(itens, trads, trad, tradCampo, lingua, props.styles, props.form, "4"));
                            
                            return (                                                                                    
                                (joins.length === 3 || total === 0)?                                
                                <Form.Row key={indice}>
                                    {joins.map(colunas => { return {...colunas} })}
                                </Form.Row>
                                :
                                null
                            )
                        }
                    })
                }
                {joins.length?
                <Form.Row>
                    {joins.map(colunas => { return {...colunas} })}
                </Form.Row>
                :
                null
                }
            </Card.Body>
        </Card>
    );    
}

const mapStateToProps = (state) => {
    return {
        pergrespevento: state.pergrespReducer
    }
}

export default connect(mapStateToProps)(PerguntasRespostas);